import { createContext, useContext } from 'react';

export type GameArrivalPhase = 'loading' | 'ready' | 'error';

export const GameArrivalContext = createContext<((phase: GameArrivalPhase) => void) | null>(null);

export function useGameArrival() {
  const report = useContext(GameArrivalContext);
  if (!report) throw new Error('Game arrival must be hosted outside the play route boundary');
  return report;
}
